// extracted by mini-css-extract-plugin
export var container = "Main-module--container--30768";
export var root = "Main-module--root--8cfac";